module.exports = __webpack_public_path__ + "static/media/hatchef.26c8c08f.svg";